import React, { useEffect, useState } from 'react';
import CustomContent from '../../../components/Content/CustomContent';
import { Button, Card, Col, Divider, Input, Modal, Row, Select, Space, Table, Typography } from 'antd';
import { deleteData, fetchData, saveData } from '../../service/dataServices';
import { DeleteOutlined, EditOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

const Dropdowns = () => {
  const [dropdowns, setDropdowns] = useState({});
  const [dropdownTypes, setDropdownTypes] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedDropdownType, setSelectedDropdownType] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [modalOperationType, setModalOperationType] = useState('Add');
  const [selectedDropdown, setSelectedDropdown] = useState();
  const [childDropdownType, setChildDropdownType] = useState(null);
  const [childTableData, setChildTableData] = useState([]);
  const [parentDetails, setParentDetails] = useState(null);
  const [isChildAdd, setIsChildAdd] = useState(false);


  const dropdownsResponse = fetchData('/api/dropdowns', response => setDropdowns(response));
  const typesResponse = fetchData('/api/dropdowns/types', response => setDropdownTypes(response));
  const saveMutation = saveData('/api/dropdowns', 'POST');
  const updateMutation = saveData('/api/dropdowns', 'PUT');
  const deleteMutation = deleteData('/api/dropdowns');

  useEffect(() => {
    if (selectedDropdownType) {
      setTableData(dropdowns[selectedDropdownType]);
    }
  }, [dropdowns]);

  const onSelect = (val) => {
    if (val && val !== '') {
      const found = dropdownTypes.find(d => d.title === val);
      if (found && found.child) {
        setChildDropdownType(found.child);
      } else {
        setChildDropdownType(null);
      }
      setTableData(dropdowns[val]);
      setSelectedDropdownType(val);
    } else {
      setTableData([]);
      setSelectedDropdownType(null);
    }
  };

  const onDelete = (id) => {
    deleteMutation.mutate({ idList: id });
    if (parentDetails && parentDetails.id === id) {
      setParentDetails(null);
      setChildTableData([])
    }
  };

  const onUpdate = (dropdown) => {
    setIsChildAdd(false);
    setSelectedDropdown(dropdown);
    setModalOperationType('Update');
    setInputValue(dropdown.title);
    setModalVisible(true);
  };

  const onUpdateChild = dropdown => {
    setIsChildAdd(true);
    setSelectedDropdown(dropdown);
    setModalOperationType('Update');
    setInputValue(dropdown.title);
    setModalVisible(true);
  }

  const onAddNew = () => {
    setIsChildAdd(false);
    setSelectedDropdown(null);
    setModalOperationType('Add');
    setInputValue('');
    setModalVisible(true);
  };

  // same
  const onAddNewChild = () => {
    setIsChildAdd(true);
    setSelectedDropdown(null);
    setModalOperationType('Add');
    setInputValue('');
    setModalVisible(true);
  };

  const onModalOk = () => {
    setModalVisible(false);
    if (inputValue && inputValue.length > 0) {
      let dataToSend = {
        'title': inputValue,
        'dropdownType': selectedDropdownType,
      };
      if (isChildAdd) {
        dataToSend.parentId = parentDetails.id;
        dataToSend.dropdownType = childDropdownType.title;
      }
      if (modalOperationType === 'Add') {
        saveMutation.mutate({ dataToSend });
      } else if (modalOperationType === 'Update') {
        updateMutation.mutate({ 'dataToSend': dataToSend, 'id': selectedDropdown.id });
      } else {
      }
    }
  };

  const onShowChildren = (dd) => {
    setChildTableData(dd.children);
    setParentDetails(dd);
  }

  useEffect(() => {
    if (dropdowns && parentDetails && selectedDropdownType) {
      const found = dropdowns[selectedDropdownType].find(dd => dd.id === parentDetails.id);
      if (found && found.children) {
        setChildTableData(found.children);
      } else {
        setChildTableData([]);
      }

    }
  }, [dropdowns])

  const convertCamelCaseToSentence = (text) => {
    if (text) {
      const result = text.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return "";
  };

  const childColumns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Update',
      key: 'update',
      render: (val) => {
        return (<Button onClick={() => onUpdateChild(val)} shape="circle" icon={<EditOutlined/>}/>);
      },
    },
    {
      title: 'Delete',
      key: 'delete',
      render: (val) => {
        return (<Button onClick={() => onDelete(val.id)} shape="circle" icon={<DeleteOutlined/>}/>);
      },
    },
  ]

  let parentColumns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Update',
      key: 'update',
      render: (val) => {
        return (<Button onClick={() => onUpdate(val)} shape="circle" icon={<EditOutlined/>}/>);
      },
    },
    {
      title: 'Delete',
      key: 'delete',
      render: (val) => {
        return (<Button onClick={() => onDelete(val.id)} shape="circle" icon={<DeleteOutlined/>}/>);
      },
    },
  ];

  if (childDropdownType) {
    parentColumns = [
      ...parentColumns,
      {
        title: 'Child',
        key: 'child',
        render: (val) => {
          return (<Button onClick={() => onShowChildren(val)} shape="circle" icon={<RightOutlined />}/>);
        },
      },
    ]
  }

  return (
    <CustomContent>
      <Row>
        <Col span={12}>
          <Space direction="horizontal" style={{ width: '100%' }} wrap>
            <Select
              showSearch
              filterOption
              optionFilterProp="children"
              placeholder="Select dropdown type"
              value={selectedDropdownType}
              allowClear
              style={{ width: '25vh' }}
              onSelect={onSelect}
              onClear={() => {
                setTableData([]);
                setSelectedDropdownType(null);
                setChildTableData([]);
                setChildDropdownType(null);
              }}
            >
              {
                dropdownTypes && dropdownTypes.map(option => (
                  <Option
                    value={option.title}
                    key={option.title}
                  >
                    {convertCamelCaseToSentence(option.title)}
                  </Option>
                ))
              }
            </Select>
          </Space>
        </Col>
      </Row>

      <Divider/>
      <Row gutter={16} align="middle" justify="center">
        <Col span={12}>
          <Card
            title={convertCamelCaseToSentence(selectedDropdownType)}
            extra={(<Button
              disabled={!(tableData.length > 0)}
              onClick={onAddNew}
              icon={<PlusOutlined/>}>
              Add New
            </Button>)}
          >
            <Table
              loading={
                dropdownsResponse.isFetching
                || saveMutation.isLoading
                || updateMutation.isLoading
                || deleteMutation.isLoading
              }
              dataSource={tableData}
              columns={parentColumns}
              rowKey={record => record.id}
              pagination={false}
              expandable={{ childrenColumnName: 'not-expandable' }}
            />
          </Card>
        </Col>
        {childDropdownType && (
          <Col span={12}>
            <Card
              title={convertCamelCaseToSentence(childDropdownType.title)}
              extra={(<Button
                disabled={parentDetails === null}
                onClick={onAddNewChild}
                icon={<PlusOutlined/>}>
                Add New
              </Button>)}
            >
              <Table
                loading={
                  dropdownsResponse.isFetching
                  || saveMutation.isLoading
                  || updateMutation.isLoading
                  || deleteMutation.isLoading
                }
                dataSource={childTableData}
                columns={childColumns}
                rowKey={record => record.id}
                pagination={false}
                expandable={{ childrenColumnName: 'not-expandable' }}
              />
            </Card>
          </Col>
        )}
      </Row>

      <Modal
        title={`${modalOperationType} Dropdown`}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={onModalOk}
        closable={false}
        destroyOnClose
        centered
      >
        <Space direction="vertical" align="center" style={{ display: 'flex' }}>
          <Input
            style={{ width: '40vh' }}
            placeholder="dropdown value"
            value={inputValue}
            onChange={val => setInputValue(val.target.value)}
          />
          <Text type="secondary">
            {isChildAdd && parentDetails && (<div>Parent: {parentDetails.title}</div>)}
          </Text>

        </Space>
      </Modal>

    </CustomContent>
  );
};

export default Dropdowns;
